// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2pFxh","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2Lz1l"};